import React, { memo } from "react";
import PropTypes from "prop-types";

import ChannelIcon from "./icons/Channel.svg";
import TeamsIcon from "./icons/Teams.svg";
import SpacesIcon from "./icons/Spaces.svg";
import ProcessIcon from "./icons/Process.svg";
import ProjectIcon from "./icons/Project.svg";
import DatasetIcon from "./icons/Dataset.svg";
import ListIcon from "./icons/List.svg";
import CaseIcon from "./icons/Case.svg";
import InfoIcon from "./icons/Info.svg";
import IntegrationIcon from "./icons/Integration.svg";
import OrganisationIcon from "./icons/Org.svg";
import ProcessFillIcon from "./icons/ProcessFill.svg";
import ProjectFillIcon from "./icons/ProjectFill.svg";
import DatasetFillIcon from "./icons/DatasetFill.svg";
import ListFillIcon from "./icons/ListFill.svg";
import CaseFillIcon from "./icons/CaseFill.svg";
import IntegrationFillIcon from "./icons/IntegrationFill.svg";

const FLOW_ICONS = {
  channel: {
    default: ChannelIcon,
    fill: ChannelIcon
  },
  team: {
    default: TeamsIcon,
    fill: TeamsIcon
  },
  space: {
    default: SpacesIcon,
    fill: SpacesIcon
  },
  org: {
    default: OrganisationIcon,
    fill: OrganisationIcon
  },
  process: {
    default: ProcessIcon,
    fill: ProcessFillIcon
  },
  project: {
    default: ProjectIcon,
    fill: ProjectFillIcon
  },
  case: {
    default: CaseIcon,
    fill: CaseFillIcon
  },
  dataset: {
    default: DatasetIcon,
    fill: DatasetFillIcon
  },
  list: {
    default: ListIcon,
    fill: ListFillIcon
  },
  system: {
    default: InfoIcon,
    fill: InfoIcon
  },
  integration: {
    default: IntegrationIcon,
    fill: IntegrationFillIcon
  }
};

export const FlowIcon = memo((props) => {
  const {
    type = "process",
    width = 54,
    height = 54,
    iconType = "default"
  } = props;

  const Icon =
    (FLOW_ICONS[type] && FLOW_ICONS[type][iconType]) ||
    FLOW_ICONS["process"]["default"];
  return <Icon width={width} height={height} />;
});

FlowIcon.propTypes = {
  type: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  iconType: PropTypes.string
};
